import React, { useState, useEffect, useRef } from 'react';
import Navbar from './components/NavBar'; // ✅ EN ÜSTE EKLE
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import citiesData from './data/CitiesData';
import SantralForm from './SantralForm';
import HeatRecoveryPage from './pages/HeatRecoveryPage';
import AdminPanel from './pages/AdminPanel';
import ContactPage from './pages/ContactPage'; // 👈 eğer eklemediysen bunu ekle
import { motion, AnimatePresence } from 'framer-motion';
import FanGroupPage from './pages/FanGroupPage';
import VRFPage from './pages/VRFPage';
import { validateUnit } from './SantralForm';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import { GoogleOAuthProvider } from '@react-oauth/google';
import IGKQuickSelectPage from './pages/IGKQuickSelectPage';
import FanQuickSelectPage from './pages/FanQuickSelectPage';
import './App.css';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation, // 🔧 eklendi
} from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import HomePage from './pages/HomePage';
import { AuthProvider } from './context/AuthContext';

const API_BASE_URL = 'https://klima-backend-ggo2.onrender.com';

function createNewUnit(id) {
  return {
    id,
    deviceType: 'ahu',  // dış ayrım için
    type: '', 
    fanFlow: '',
    recoveryConfig: '',
    fanPressure: '',
    aspFlow: '',
    aspPressure: '',
    heatingNeed: '',
    heatingType: '',
    heatingCapacity: '',
    coolingNeed: '',
    coolingType: '',
    coolingCapacity: '',
    humidNeed: '',
    humidType: '',
    humidCapacity: '',
    advancedEnabled: false,
    winterTemp: 22,
    summerTemp: 24,
    customWidth: '',
    customLength: '',
    customHeight: '',
    isHygienic: false,
    silencer: 'hayir',
    silencerFan: false,
    silencerExhaust: false,
    recoveryType: '',
    mixingType: '',
  };
}

function DesignPage() {
  const [projectName, setProjectName] = useState('');
  const [location, setLocation] = useState('');
  const [editingClimate, setEditingClimate] = useState(false);
  const [climateData, setClimateData] = useState({
    altitude: '',
    winterDB: '',
    summerDB: '',
    summerWB: '',
  });

  const [units, setUnits] = useState([createNewUnit(1)]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [username, setUsername] = useState('');
const [showDropdown, setShowDropdown] = useState(false);
const [climateManuallyEdited, setClimateManuallyEdited] = useState(false);
const [ahuNotes, setAhuNotes] = useState('');
  const pdfRef = useRef();

  const navigate = useNavigate();
  const locationState = useLocation(); // 🔧 eklendi
  const queryParams = new URLSearchParams(locationState.search); // 🔧 eklendi
  const editProjectId = queryParams.get('edit'); // 🔧 eklendi

 useEffect(() => {
  const token = localStorage.getItem('token');
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      setUsername(payload.username || 'Ziyaretçi');
    } catch {
      setUsername('Ziyaretçi');
    }
  } else {
    setUsername('Ziyaretçi');
  }
}, []);

 
 
  // 🔧 Eğer edit modundaysa proje verisini çek
   useEffect(() => {
    if (editProjectId) {
      const token = localStorage.getItem('token');
      fetch(`${API_BASE_URL}/api/projects/${editProjectId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
       .then((data) => {
  setProjectName(data.projectName || '');
  setLocation(data.location || '');
  setClimateData({
    altitude: data.altitude || '',
    winterDB: data.winterDryTemp || '',
    summerDB: data.summerDryTemp || '',
    summerWB: data.summerWetTemp || '',
  });

  setClimateManuallyEdited(true); // ⬅️ burayı EKLE!

         if (Array.isArray(data.units)) {
  console.log('🔍 Tüm Gelen Units:', data.units);
const onlyAhuUnits = data.units
  .filter((u) => u.deviceType === 'ahu')
  .map((u, i) => ({
    id: u.id ?? i + 1,
    type: u.type ?? '', // 🧠 garantiye al
    ...u,
  }));
console.log('✅ Sadece AHU Units:', onlyAhuUnits);

setUnits(onlyAhuUnits.length > 0 ? onlyAhuUnits : [createNewUnit(1)]);

} else {
  setUnits([createNewUnit(1)]);
}




setUploadedFiles(
  (data.uploadedFiles || []).map(f => ({
    originalName: f.originalName || '',
    serverName: f.serverName || '',
    size: f.size || null
  }))
);

setAhuNotes(data.ahuNotes || '');


        })
        .catch((err) => {
          console.error('Proje verisi alınamadı:', err);
          alert('Proje verisi alınamadı.');
        });
    }
  }, [editProjectId]);

 useEffect(() => {
  const selectedCity = citiesData.find(
    (city) => city.name === location.toUpperCase()
  );

  if (!selectedCity) return;

  setClimateData(prev => {
    const isEmpty =
      prev.altitude === '' &&
      prev.winterDB === '' &&
      prev.summerDB === '' &&
      prev.summerWB === '';

    // Yalnızca kullanıcı değiştirmemişse ya da şehir değiştiğinde veriyle eşit değilse güncelle
    const changedCity =
      selectedCity.altitude !== Number(prev.altitude) ||
      selectedCity.winterDB !== Number(prev.winterDB) ||
      selectedCity.summerDB !== Number(prev.summerDB) ||
      selectedCity.summerWB !== Number(prev.summerWB);

    if ((isEmpty || changedCity) && !climateManuallyEdited) {
      return {
        altitude: selectedCity.altitude,
        winterDB: selectedCity.winterDB,
        summerDB: selectedCity.summerDB,
        summerWB: selectedCity.summerWB,
      };
    }

    return prev;
  });
}, [location]);


  const handleAddUnit = () => {
    const nextId = units.length + 1;
    setUnits([...units, createNewUnit(nextId)]);
  };

  const handleCopyUnit = (unitToCopy) => {
    const nextId = units.length + 1;
    const copiedUnit = { ...unitToCopy, id: nextId };
    setUnits([...units, copiedUnit]);
  };

  const handleDeleteUnit = (id) => {
  if (window.confirm('Bu klima santralini silmek istediğinize emin misiniz?')) {
    setUnits(prev => prev.filter(unit => unit.id !== id));
  }
};

  const handleUnitChange = (id, newData) => {
    setUnits(units.map((unit) => (unit.id === id ? { ...unit, ...newData } : unit)));
  };

 const handleFileUpload = (e) => {
  const files = Array.from(e.target.files);
  const currentSize = uploadedFiles.reduce((total, f) => total + (f.size || 0), 0);
  const newSize = files.reduce((total, f) => total + f.size, 0);
  const totalSizeMB = (currentSize + newSize) / (1024 * 1024);

  if (totalSizeMB > 30) {
    alert('Toplam dosya boyutu 30 MB\'ı geçemez.');
    return;
  }

  for (let file of files) {
    if (file.size > 5 * 1024 * 1024) {
      alert(`${file.name} dosyası 5 MB'tan büyük. Lütfen daha küçük bir dosya seçin.`);
      return;
    }
  }

  // Sadece belleğe al, yükleme işlemini daha sonra yapacağız
  const tempFiles = files.map((file) => ({
    file, // gerçek File objesi
    originalName: file.name,
    size: file.size
  }));

  setUploadedFiles(prev => [...prev, ...tempFiles]);
};


const handleDeleteFile = async (file) => {
  if (!window.confirm(`${file.originalName} dosyasını silmek istiyor musunuz?`)) return;

  // Eğer serverName yoksa (yani daha sunucuya yüklenmemişse), sadece local'den sil
  if (!file.serverName) {
    setUploadedFiles(prev =>
  prev.filter(f =>
    f.serverName !== file.serverName || f.originalName !== file.originalName
  )
);
    return;
  }

  // Eğer sunucudaysa, normal silme işlemi yapılır
  try {
   const response = await fetch(`${API_BASE_URL}/api/upload/delete-file`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ fileName: file.serverName }),
    });

    if (response.ok) {
      setUploadedFiles(prev =>
  prev.filter(f =>
    !(f.serverName === file.serverName && f.originalName === file.originalName)
  )
);

      console.log('🗑️ Dosya silindi:', file.originalName);
    } else {
      console.error('❌ Sunucu silme hatası:', response.statusText);
      alert('Dosya silinirken hata oluştu.');
    }
  } catch (err) {
    console.error('❌ İstek gönderme hatası:', err);
    alert('Dosya silinirken ağ hatası oluştu.');
  }
};

  const generatePDF = () => {
    const input = pdfRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
      heightLeft -= pdf.internal.pageSize.getHeight();

      while (heightLeft > 0) {
        position -= pdf.internal.pageSize.getHeight();
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
        heightLeft -= pdf.internal.pageSize.getHeight();
      }

      pdf.save('klima_santrali_tasarimi.pdf');
    });
  };

const getUnitName = (id) => {
  if (typeof id !== 'number' && typeof id !== 'string') return 'KS-XX';
  return `KS-${id.toString().padStart(2, '0')}`;
};


  // 🔧 Projeyi kaydederken PUT mu POST mu karar ver
 const handleSaveProject = async () => {
  if (username === 'Ziyaretçi') {
    alert('Projeyi Kaydedebilmek İçin Lütfen Giriş Yapınız.');
    return;
  }

  const allErrors = units.flatMap((unit, i) =>
    validateUnit(unit).map(err => `Santral ${i + 1}: ${err}`)
  );

  if (allErrors.length > 0) {
    alert('Lütfen aşağıdaki hataları düzeltin:\n\n' + allErrors.join('\n'));
    return;
  }

  // 🧷 Dosya yükleme
  let uploadedServerFiles = [];

  if (uploadedFiles.length > 0) {
    const formData = new FormData();
    const newFiles = uploadedFiles.filter(f => !f.serverName && f.file);
    newFiles.forEach(f => formData.append('files', f.file));

    try {
      const uploadResponse = await fetch(`${API_BASE_URL}/api/upload`, {
        method: 'POST',
        body: formData,
      });

      const uploadData = await uploadResponse.json();

      if (!uploadResponse.ok) throw new Error('Dosya yükleme başarısız.');

      uploadedServerFiles = uploadedFiles.map((file, idx) => {
        if (file.serverName) {
          return file;
        } else if (uploadData.uploadedFiles && uploadData.uploadedFiles[idx]) {
          return {
            serverName: uploadData.uploadedFiles[idx],
            originalName: file.originalName,
            size: file.size,
          };
        } else {
          console.warn('❗ uploadData eksik, bu dosya atlandı:', file);
          return null;
        }
      }).filter(f => f !== null);

    } catch (err) {
      console.error('📤 Dosya yükleme hatası:', err);
      alert('Dosya yüklenirken bir hata oluştu.');
      return;
    }
  }

  const token = localStorage.getItem('token');
  let existingUnits = [];

  // 🔍 Projenin tamamı alınır, diğer cihazları korumak için
  if (editProjectId && token) {
    try {
      const res = await fetch(`${API_BASE_URL}/api/projects/${editProjectId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      existingUnits = Array.isArray(data.units) ? data.units : [];
    } catch (err) {
      console.warn('Mevcut üniteler alınamadı:', err);
    }
  }

  const updatedUnits = [
    ...existingUnits.filter((u) => u.deviceType !== 'ahu'),
    ...units.map((u, i) => ({
      ...u,
      id: u.id ?? i + 1,
      deviceType: 'ahu',
    }))
  ];

  const projectData = {
    projectName,
    location,
    altitude: Number(climateData.altitude),
    winterDryTemp: Number(climateData.winterDB),
    summerDryTemp: Number(climateData.summerDB),
    summerWetTemp: Number(climateData.summerWB),
    units: updatedUnits,
    uploadedFiles: uploadedServerFiles
      .filter(f => f && f.serverName && f.originalName)
      .map(f => ({
        serverName: f.serverName,
        originalName: f.originalName,
        size: f.size || null,
      })),
    updatedAt: new Date().toISOString(),
    ahuNotes,
  };

  const method = editProjectId ? 'PUT' : 'POST';
  const endpoint = editProjectId
    ? `${API_BASE_URL}/api/projects/${editProjectId}`
    : `${API_BASE_URL}/api/projects`;

  try {
    const response = await fetch(endpoint, {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(projectData),
    });

    if (!response.ok) {
      const text = await response.text();
      console.error('🛑 Sunucu yanıtı:', text);
      throw new Error('Proje kaydedilemedi.');
    }

    alert('✅ Proje başarıyla kaydedildi!');
    navigate('/panel');
  } catch (error) {
    alert('❌ Proje kaydedilirken hata oluştu: ' + error.message);
    console.error('Kaydetme hatası:', error);
  }
};


 return (
  <>
    <Navbar username={username} />
    <div style={{ padding: 20, maxWidth: '1400px', margin: 'auto' }}>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
  <h1>Klima Santrali Tasarımı</h1>



</div>


    <div ref={pdfRef} className="pdf-section">
  <div className="form-row align-center" style={{ position: 'relative' }}>
    <label>Proje İsmi:</label>
    <input
      type="text"
      value={projectName}
      onChange={(e) => setProjectName(e.target.value)}
      readOnly={username === 'Ziyaretçi'}
      placeholder={username === 'Ziyaretçi' ? '' : 'Proje ismini giriniz'}
      style={{
        backgroundColor: username === 'Ziyaretçi' ? '#f0f0f0' : '#fff',
        border: '1px solid #ccc',
        borderRadius: 6,
        padding: '8px 10px',
        fontSize: '16px',
        height: 38,
        lineHeight: '1.2',
        width: '200px',
        marginRight: 12,
        boxSizing: 'border-box',
        cursor: username === 'Ziyaretçi' ? 'not-allowed' : 'auto',
      }}
      title={
        username === 'Ziyaretçi'
          ? 'Değer girebilmek için lütfen giriş yapınız.'
          : ''
      }
    />
  </div>

  <div className="form-row align-center" style={{ position: 'relative' }}>
    <label>Proje Konumu:</label>
    <input
      type="text"
      value={location}
      disabled
      style={{
        backgroundColor: '#f0f0f0',
        border: '1px solid #ccc',
        borderRadius: 6,
        padding: '8px 10px',
        fontSize: '16px',
        height: 38,
        lineHeight: '1.2',
        width: '200px',
        marginRight: 12,
        boxSizing: 'border-box',
        cursor: username === 'Ziyaretçi' ? 'not-allowed' : 'auto',
      }}
      title={
        username === 'Ziyaretçi'
          ? 'Değer girebilmek için lütfen giriş yapınız.'
          : ''
      }
    />

          {!editingClimate ? (
            <>
              <span className="climate-info">
                Rakım: {climateData.altitude} m | Kış KT: {climateData.winterDB} °C | Yaz
                KT: {climateData.summerDB} °C | Yaz YT: {climateData.summerWB} °C
              </span>
            

            </>
          ) : (
            <div className="climate-edit">
              {['altitude', 'winterDB', 'summerDB', 'summerWB'].map((key, i) => (
                <div key={i}>
                  <label>{key}:</label>
                  <input
                    type="number"
                    value={climateData[key]}
                    onChange={(e) =>
                      setClimateData({ ...climateData, [key]: e.target.value })
                    }
                  />
                </div>
              ))}
              <button className="btn-small" onClick={() => setEditingClimate(false)}>
                Kaydet
              </button>
            </div>
          )}
        </div>

       <AnimatePresence>
  {units.map((unit) => (
    <motion.div
      key={unit.id}
      className="unit-card"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.3 }}
      style={{ position: 'relative', paddingTop: 40 }} // üst boşluk veriyoruz
    >
      {/* 🔴 Sil Butonu: Sağ üst köşeye yerleşmiş */}
      <button
        onClick={() => handleDeleteUnit(unit.id)}
        style={{
          position: 'absolute',
          top: 10,
          right: 10,
          backgroundColor: '#e53935',
          color: 'white',
          border: 'none',
          borderRadius: 6,
          padding: '4px 10px',
          fontSize: 13,
          cursor: 'pointer',
          boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
        }}
        title="Santrali Sil"
      >
        Sil
      </button>

      <SantralForm
        unit={unit}
        onChange={(newData) => handleUnitChange(unit.id, newData)}
        onCopy={() => handleCopyUnit(unit)}
      />

      <button className="btn-copy" onClick={() => handleCopyUnit(unit)}>
        📝 {getUnitName(unit.id)} Santralini Kopyala
      </button>
    </motion.div>
  ))}
</AnimatePresence>

      </div>

      <button className="btn-add" onClick={handleAddUnit}>
        ➕ Yeni Santral Ekle
      </button>

<div style={{ margin: '20px 0' }}>
  <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 6 }}>Notlar:</label>
  <textarea
    value={ahuNotes}
onChange={(e) => setAhuNotes(e.target.value)}
    placeholder="Varsa ekstra notlarınızı buraya yazabilirsiniz..."
    style={{
      width: '100%',
      minHeight: 100,
      padding: '10px',
      fontSize: '15px',
      border: '1px solid #ccc',
      borderRadius: 6,
      resize: 'vertical',
    }}
  />
</div>


     <div className="btn-group" style={{ display: 'flex', gap: 10 }}>
  <button className="btn-save" onClick={handleSaveProject}>
    💾 Projeyi Kaydet
  </button>
  <button className="btn-pdf" onClick={generatePDF}>
    📄 PDF Oluştur 
  </button>
  <button
  onClick={() => navigate('/panel')}
  style={{
    backgroundColor: '#9e9e9e',
    color: 'white',
    padding: '10px 16px',
    border: 'none',
    borderRadius: 6,
    fontSize: 15,
    fontWeight: 'bold', // 🔹 Yazı kalınlığı
    fontFamily: 'Arial, sans-serif', // 🔹 İsteğe göre değiştirebilirsin
    cursor: 'pointer',
  }}
>
  Vazgeç
</button>

</div>

    </div>
  </>

  );
}

function App() {
  return (
    <GoogleOAuthProvider clientId="677792463105-gh52unmuak1agig1dvldo570q4s5er39.apps.googleusercontent.com">
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tasarim" element={<DesignPage />} />
            <Route path="/giris" element={<LoginPage />} />
            <Route path="/kayit" element={<RegisterPage />} />
            <Route path="/panel" element={<DashboardPage />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/igk" element={<HeatRecoveryPage />} />
            <Route path="/iletisim" element={<ContactPage />} />
            <Route path="/fan" element={<FanGroupPage />} />
            <Route path="/vrf" element={<VRFPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/igk-secim" element={<IGKQuickSelectPage />} />
            <Route path="/fan-secim" element={<FanQuickSelectPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}


export default App;
